import { MILESTONES } from '@constants/check-in/constants'

export const getMileStone = (value) => {
  const milestone = MILESTONES.reduce((acc, curr) => {
    if (curr <= value && curr > acc) {
      return curr
    }
    return acc
  })
  return milestone
}
